const TimeService = (instance) => {
  const getTime = () => instance.get(window.config?.timeApi?.endPoint);

  return {
    getTime,
  };
};
export default TimeService;
